/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(179));
	    processInclude(__webpack_require__(57));
	    processInclude(__webpack_require__(65));
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Remove all validation. Should be called every time before revalidating form
	 * @param {element} form - Form to be cleared
	 * @returns {void}
	 */

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function clearFormErrors(form) {
	    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
	}

	module.exports = function (formElement, payload) {
	    // clear form validation first
	    clearFormErrors(formElement);
	    $('.alert', formElement).remove();

	    if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && payload.fields) {
	        Object.keys(payload.fields).forEach(function (key) {
	            if (payload.fields[key]) {
	                var feedbackElement = $(formElement).find('[name="' + key + '"]').parents('.cc-form-group').find('.invalid-feedback');

	                if (feedbackElement.length > 0) {
	                    if (Array.isArray(payload[key])) {
	                        feedbackElement.find('.cc-text-message').html(payload.fields[key].join('<br/>'));
	                    } else {
	                        feedbackElement.find('.cc-text-message').html(payload.fields[key]);
	                    }
	                    feedbackElement.siblings('.form-control').addClass('is-invalid');
	                    feedbackElement.show();
	                    feedbackElement[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                }
	            }
	        });
	    }
	    if (payload && payload.error) {
	        var form = $(formElement).prop('tagName') === 'FORM' ? $(formElement) : $(formElement).parents('form');

	        form.prepend('<div class="alert alert-danger" role="alert">' + payload.error.join('<br/>') + '</div>');
	    }
	};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	    $(document).on('click', '.js-togglePassword', function () {
	        var self = $(this);
	        self.parent().find('.js-form-password').attr('type', self.parent().find('.js-form-password').is(':password') ? 'text' : 'password');
	        if (self.parent().find('.js-form-password').attr('type') === 'password') {
	            self.closest('.cc-content-input').removeClass('js-passwordShow cc-account__viewPassword');
	        } else {
	            self.closest('.cc-content-input').addClass('js-passwordShow cc-account__viewPassword');
	            setTimeout(function () {
	                if (self.closest('.cc-content-input').hasClass('js-passwordShow cc-account__viewPassword')) {
	                    self.click();
	                    self.closest('.cc-content-input').removeClass('js-passwordShow cc-account__viewPassword');
	                }
	            }, 5000);
	        }
	    });
	};

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Validate whole form. Requires `this` to be set to form object
	 * @param {jQuery.event} event - Event to be canceled if form is invalid.
	 * @returns {boolean} - Flag to indicate if form is valid
	 */

	function _validateForm(event) {
	    var valid = true;
	    if (this.checkValidity && !this.checkValidity()) {
	        // safari
	        valid = false;
	        if (event) {
	            event.preventDefault();
	            event.stopPropagation();
	            event.stopImmediatePropagation();
	        }
	        $(this).find('input, select, textarea').each(function () {
	            if (!this.validity.valid) {
	                $(this).trigger('invalid', this.validity);
	            }
	        });
	    }
	    return valid;
	}

	/**
	 * Remove all validation. Should be called every time before revalidating form
	 * @param {element} form - Form to be cleared
	 * @returns {void}
	 */
	function clearForm(form) {
	    $(form).find('.form-control.is-invalid').not('.custom-error').removeClass('is-invalid');
	    $(form).find('.cc-phone-input-box.is-invalid').not('.custom-error').removeClass('is-invalid');
	    $(form).find('.cc-is-invalid-container').removeClass('cc-is-invalid-container');
	}

	//eslint-disable-next-line complexity
	function insertInvalid(field) {
	    var validationMessage;
	    if (typeof field.validationMessage !== 'undefined') {
	        validationMessage = field.validationMessage;
	    } else {
	        validationMessage = field[0].validationMessage;
	        field = field[0];
	    }

	    if ($(field).data('rut-validation-enable')) {
	        if ($(field).find('.custom-error, .is-invalid').length === 0 && validationMessage.length === 0) {
	            validationMessage = $(field).data('external-rut-validation-error');
	        }
	    }
	    if ($(field).data('max-acceptable-length')) {
	        if ($(field).val().length > parseInt($(field).data('max-acceptable-length'))) {
	            validationMessage = $(field).data('max-acceptable-length-error');
	        }
	    }

	    if ($(field).hasClass('js-check-email')) {
	        if ($(field).find('.custom-error, .is-invalid').length === 0 && validationMessage.length === 0) {
	            validationMessage = $(field).data('email-exist');
	        }
	    }

	    if ($(field).data('max') && $(field).val().length > parseInt($(field).data('max'))) {
	        validationMessage = $(field).data('maxlength-error');
	    }

	    if ($(field).attr('minlength') && $(field).val().length < parseInt($(field).attr('minlength'))) {
	        validationMessage = $(field).data('minlength-error');
	    }

	    if (!field.validity.valid) {
	        if ($(field).closest('.js-phone-box-validator').find('.cc-phone-prefix').length) {
	            $(field).closest('.js-phone-box-validator').addClass('is-invalid');
	        } else {
	            $(field).addClass('is-invalid');
	        }
	        //$(this).addClass('cc-invalid');
	        $(field).closest('.cc-content-select').addClass('cc-is-invalid-container');
	        if (field.validity.patternMismatch && $(field).data('pattern-mismatch')) {
	            validationMessage = $(field).data('pattern-mismatch');
	        }
	        if ($(field).data('max-length-acceptable') !== null && $(field).data('range-error') && $(field).val().length > parseInt($(field).data('max-length-acceptable'))) {
	            validationMessage = $(field).data('range-error');
	        }
	        if ((field.validity.rangeOverflow || field.validity.rangeUnderflow) && $(field).data('range-error')) {
	            validationMessage = $(field).data('range-error');
	        }
	        if (field.validity.tooLong && ($(field).data('maxlength-error') || $(field).data('range-error'))) {
	            validationMessage = $(field).data('maxlength-error') || $(field).data('range-error');
	        }
	        if (field.validity.tooShort && ($(field).data('minlength-error') || $(field).data('range-error'))) {
	            validationMessage = $(field).data('minlength-error') || $(field).data('range-error');
	        }
	        if (field.validity.valueMissing && $(field).data('missing-error')) {
	            validationMessage = $(field).data('missing-error');
	        }
	        if (field.validity.typeMismatch && $(field).data('type-mismatch')) {
	            validationMessage = $(field).data('type-mismatch');
	        }

	        if ($(field).hasClass('js-validation-add-tick')) {
	            if ($(field).is('input')) {
	                $(field).closest('.cc-content-input').removeClass('cc-tick-ok is-valid');
	                $('.cc-valid-success').addClass('d-none');
	            }
	            if ($(field).is('select')) {
	                $(field).closest('.cc-content-select').removeClass('cc-tick-ok');
	            }
	        }
	    }
	    if ($(field).parents('.cc-form-group').find('.cc-text-message').length) {
	        $(field).parents('.cc-form-group').find('.cc-text-message').text(validationMessage);
	    } else {
	        $(field).parents('.cc-form-group').find('.invalid-feedback').text(validationMessage);
	    }
	}

	function removeInvalid(field) {
	    if (typeof field.setCustomValidity !== 'undefined') {
	        field.setCustomValidity('');
	    } else {
	        field = field[0];
	        field.setCustomValidity('');
	    }
	    if (field.validity.valid) {
	        $(field).removeClass('is-invalid');
	        // some fields are inside a container which is marked as invalid -> remove the class in case
	        var $elementInvalidFormContainer = $(field).closest('.form-control.is-invalid');
	        if ($elementInvalidFormContainer.length) {
	            $elementInvalidFormContainer.removeClass('is-invalid');
	        }
	        $(field).closest('.cc-content-select').removeClass('cc-is-invalid-container');
	        $(field).closest('.cc-phone-input-box').removeClass('is-invalid');
	        $(field).closest('.cc-content-select').find('.cc-select').removeClass('is-invalid');
	        $('.js-input-title-radio').each(function () {
	            if ($(this).prop('checked')) {
	                $('.js-input-title-radio').removeClass('is-invalid');
	            }
	        });
	        $(field).parents('.cc-form-group').find('.cc-text-message').text('');
	        if ($(field).hasClass('js-validation-add-tick')) {
	            if ($(field).is('input')) {
	                $(field).closest('.cc-content-input').addClass('cc-tick-ok');
	                $(field).closest('.cc-content-input').find('.cc-valid-success').removeClass('d-none');
	            }
	            if ($(field).is('select')) {
	                $(field).closest('.cc-content-select').addClass('cc-tick-ok');
	                $(field).closest('.cc-content-select').find('.cc-valid-success').addClass('d-none');
	            }
	        }
	    }
	}

	function validateMaxAcceptableLength(field) {
	    if (!$(field).data('max-acceptable-length')) {
	        return;
	    }
	    field.setCustomValidity('');

	    var $field = $(field);
	    var fieldLength = $field.val().length;
	    var maxLength = $field.data('max-acceptable-length');
	    if (fieldLength > maxLength) {
	        // If blank space is the last character over the limit,
	        // then it is deleted and the error is not triggered
	        if ($field.val()[maxLength] === ' ') {
	            var trimmedAddress = $field.val().trimEnd();
	            $field.val(trimmedAddress);
	            $field.parents('.cc-form-group').find('.js-field-length-counter').text($field.val().length);
	        } else {
	            field.setCustomValidity($field.data('max-acceptable-length-error'));
	            $field.siblings('.cc-form-description').addClass('is-invalid');
	            // For mobile: Address is cut off at the max length + 1
	            if (fieldLength > maxLength + 1) {
	                $field.val($field.val().slice(0, maxLength + 1));
	            }
	        }
	    } else if ($field.siblings('.cc-form-description').hasClass('is-invalid')) {
	        $field.siblings('.cc-form-description').removeClass('is-invalid');
	    }
	}

	function validateField(field) {
	    validateMaxAcceptableLength(field);
	    var isValidationSuccessful = true;
	    if (field.validity) {
	        if (!field.validity.valid) {
	            insertInvalid(field);
	            isValidationSuccessful = false;
	        } else {
	            removeInvalid(field);
	        }
	    }
	    $(field).trigger('fieldValidated', {
	        isValid: isValidationSuccessful
	    });

	    $(field).trigger('validateRUT', {
	        isValid: isValidationSuccessful,
	        insertInvalid: insertInvalid.bind(null, $(field)),
	        removeInvalid: removeInvalid.bind(null, $(field))
	    });
	}

	function validationForm(element) {
	    var $form = $(element).closest('form');
	    clearForm($form);
	    $form.find('input, select, textarea').each(function () {
	        insertInvalid(this);
	    });
	    var $invalidElements = $('.is-invalid, .custom-error');
	    if ($invalidElements.length > 0) {
	        var $formGroup = $invalidElements.first().parents('.cc-form-group');
	        if ($formGroup.length > 0) {
	            $formGroup[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	        }
	    }
	}

	function validateNoMandatoryField(field) {
	    validateMaxAcceptableLength(field);
	    if (field.validity) {
	        if (!field.validity.valid) {
	            insertInvalid(field);
	        } else {
	            removeInvalid(field);
	        }
	    }
	    var checkIfValueIsEmpty = $(field).val();
	    if ($(field).hasClass('js-validation-add-tick')) {
	        if (checkIfValueIsEmpty === "") {
	            $(field).closest('.cc-content-input').removeClass('cc-tick-ok');
	        }
	    }
	}

	module.exports = {

	    invalid: function invalid() {
	        $('form input, form select, form textarea').on('invalid', function (e) {
	            e.preventDefault();
	            insertInvalid(this);
	            //$(this).parents('.cc-form-group').find('.cc-error-message').show();
	        });
	    },

	    submit: function submit() {
	        $('form').on('submit', function (e) {
	            // e.preventDefault();
	            return _validateForm.call(this, e);
	        });

	        // validation called in case the submit of the form comes from a button of type 'button'
	        $('body').on('validateOnSubmit', function (e, form) {
	            return _validateForm.call(form, e);
	        });
	    },

	    buttonClick: function buttonClick() {
	        $('form button[type="submit"], form input[type="submit"]').on('click', function () {
	            validationForm(this);
	        });
	    },
	    //Temporary solution
	    buttonClickAjax: function buttonClickAjax() {
	        $(document).on('click', 'form.js-ajaxCall button[type="submit"], form.js-ajaxCall input[type="submit"]', function () {
	            validationForm(this);
	        });
	    },

	    validateOnChange: function validateOnChange() {
	        $('body').on('change', '.js-validate-on-change', function () {
	            if ($(this).prop('required')) {
	                validateField(this);
	            } else {
	                validateNoMandatoryField(this);
	            }
	        });
	    },

	    avoidLettersOnInput: function avoidLettersOnInput() {
	        $('body').on('input', '.js-avoid-letter-on-input', function () {
	            this.value = this.value.replace(/[^0-9]/g, '');
	        });
	    },

	    validateOnInput: function validateOnInput() {
	        $('body').on('input', '.js-validate-on-input', function () {
	            if ($(this).prop('required')) {
	                validateField(this);
	            } else {
	                validateNoMandatoryField(this);
	            }
	        });
	    },

	    checkRut: function checkRut() {
	        $('#rut-validation-checkout').on('change', function () {
	            var $rut = $(this);
	            validateField($rut);
	        });
	    },

	    inputFromDropdownList: function inputFromDropdownList() {
	        $('[id^="dni-validation-"]').on('change', function () {
	            var $dni = $(this)[0];
	            validateField($dni);
	        });
	    },

	    validateCheckBoxesOnChange: function validateCheckBoxesOnChange() {
	        $('.js-validation-checkbox').on('change', function () {
	            var $checkBox = $(this);
	            $checkBox.removeClass('is-invalid');
	            if ($checkBox.prop("checked") === false && $checkBox.closest('.cc-form-group').hasClass('required')) {
	                $checkBox.addClass('is-invalid');
	                $checkBox.parents('.cc-form-group').find('.invalid-feedback').text($checkBox.data('missing-error'));
	                $('body').trigger('FE_validation:fieldValidated', { element: $(this), valid: false });
	            } else {
	                $('body').trigger('FE_validation:fieldValidated', { element: $(this), valid: true });
	            }
	        });
	    },

	    dropdownLists: function dropdownLists() {
	        $('#documentPick').on('change', function () {
	            $('[id^="dni-validation-"]').val('');
	            $('.cc-valid-success').addClass('d-none');
	            var $dni = $('[id^="dni-validation-"]');
	            $($dni[0]).removeClass('is-invalid');
	            $($dni[0]).closest('.cc-content-input').removeClass('cc-tick-ok');
	        });
	    },

	    functions: {
	        validateForm: function validateForm(form, event) {
	            _validateForm.call($(form), event || null);
	        },
	        clearForm: clearForm
	    },

	    validateCedulaForm: function validateCedulaForm($field) {
	        if ($field && $field[0]) {
	            return validateField($field[0]);
	        }
	        return null;
	    }
	};

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    /**
	     * Update length displayed by the counter associated with the field itself
	     */
	    updateFieldLengthCounter: function updateFieldLengthCounter() {
	        $('body').on('input', '.js-has-length-counter', function () {
	            var inputLength = $(this).val().length;
	            $(this).parents('.cc-form-group').find('.js-field-length-counter').text(inputLength);
	        });
	    },

	    updateAllAddressLengthCounters: function updateAllAddressLengthCounters() {
	        var customElemArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	        if (customElemArray === null) {
	            $.each($('.js-has-length-counter'), function (ind, element) {
	                $(element).parents('.cc-form-group').find('.js-field-length-counter').text(element.value.length);
	                if ($(element).data('max-acceptable-length') < element.value.length) {
	                    $(element).parents('.cc-form-group').find('.cc-counter').addClass('is-invalid');
	                } else {
	                    $(element).parents('.cc-form-group').find('.cc-counter').removeClass('is-invalid');
	                }
	            });
	        }
	    }
	};

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-native-reassign */
	'use strict';

	var formValidation = __webpack_require__(1);

	var CSS_ERROR_CLASSES = 'is-invalid custom-error';
	var clientSideValidation = __webpack_require__(59);

	var registration_form_email_oldVal;
	var registration_form_phone_oldVal;
	var registration_form_zipCode_oldVal;
	var email_by_phone;
	var customerId_by_phone;
	var customerId_by_email;
	var user_already_registered = false;
	var use_another_email = false;
	var number_already_registered = false;
	var valid_number = true;
	var use_same_number_string;
	var valid_email;
	var hasValidLoyaltyEmail = false;
	var $checkEmailConsistency = $('#registration-form-email').data('check-email-consistency');

	var formName = $('#myform').attr('name');

	/**
	 * Regex to check if the string passed is a valid e-mail address
	 */
	function isValidEmailAddress(emailAddressToValidate) {
	    var regexEmailString = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
	    return regexEmailString.test(emailAddressToValidate);
	}

	/**
	 * Logic that will check if identifier's radio button is valid
	 * @param {*} form the submitted form
	 * @param {String} identifier the form's identifier
	 */
	function validateLegalButton(form, identifier) {
	    var $element = $('#' + identifier);
	    var validateAcceptance = $element.data('acceptance-mandatory') === true;
	    if (validateAcceptance) {
	        // eslint-disable-next-line no-global-assign
	        var formMarketingOptIn = form[name = formName + '_customer_' + identifier];
	        var isAccepted = formMarketingOptIn.value === 'true';
	        if (!isAccepted) {
	            var notAcceptedErrorText = $element.data('not-accepted-error');
	            $(formMarketingOptIn).parents('.cc-form-group').find('.cc-text-message').text(notAcceptedErrorText);
	            $(formMarketingOptIn).addClass(CSS_ERROR_CLASSES);
	        } else {
	            $(formMarketingOptIn).removeClass(CSS_ERROR_CLASSES);
	        }
	    }
	}

	function birthdayValidation(fieldId) {
	    var dateOfBirthField = $(fieldId);

	    if (dateOfBirthField.length) {

	        var selectedDate = dateOfBirthField.val();
	        var dobParent = dateOfBirthField.parents('.js-date-select');
	        var isRequired = $(dobParent).hasClass('required');

	        if (dobParent.length) {
	            var errorLabel = $(dobParent).find('.js-date-error.invalid-feedback');

	            if (selectedDate || !isRequired) {
	                $(dobParent);
	                errorLabel.removeClass('custom-birthday-error');
	                errorLabel.hide();
	                $(dobParent).find('.js-input_datepicker').removeClass('is-invalid custom-error');
	            } else {
	                var errorMessage = $(dobParent).data('invalid-date-message');
	                errorLabel.find('.js-message').html(errorMessage);
	                errorLabel.addClass('custom-birthday-error');
	                errorLabel.show();
	                $(dobParent).find('.js-input_datepicker').addClass('is-invalid custom-error');
	            }
	        }
	    }
	}

	/**
	 * Handles frontend validation for address fields in the registration form.
	 * Dynamically adds or removes the 'required' attribute on inputs/selects within the #returnAccordion section,
	 * based on visibility and the 'data-required-for-offlineRegistration' attribute.
	 * This ensures the form can only be submitted when all required fields are filled.
	 * @function registrationAddressFormValidation
	 */
	function registrationAddressFormValidation() {
	    var $optionalAddressAccordion = $('#optionalAddressAccordion');
	    if ($optionalAddressAccordion.length && $optionalAddressAccordion.is(':visible')) {
	        $optionalAddressAccordion.find('input, select, button').each(function () {
	            var requiredForOffline = $(this).attr('data-required-for-offlineRegistration');
	            if (requiredForOffline && requiredForOffline === 'true' || this.tagName.toLowerCase() === 'select') {
	                $(this).attr('required', true);
	            } else {
	                $(this).removeAttr('required');
	                $(this).removeAttr('aria-required');
	                $(this).removeClass('bs-invalid');
	                $(this).removeClass('is-invalid');
	            }
	        });
	    } else if ($optionalAddressAccordion.length) {
	        $optionalAddressAccordion.find('input, select, button').each(function () {
	            $(this).removeAttr('required');
	            $(this).removeAttr('aria-required');
	            $(this).removeClass('is-invalid');
	            $(this).removeClass('bs-invalid');
	        });
	    }
	}

	/**
	 * this class will di additional validation.
	 * In case validation fails, an error will be shown on each form field with classes 'is-invalid custom-error', otherwhise removed
	 * if classes are set, then form cannot be submitted
	 * @param {*} form the form to verify
	 */
	function doAdditionalErrorCheck(form) {
	    var legalRadioButtons = ['termsAndConditions', 'marketingOptIn', 'profilation'];
	    for (var i = 0; i < legalRadioButtons.length; i++) {
	        if ($('#' + legalRadioButtons[i]).length) {
	            validateLegalButton(form, legalRadioButtons[i]);
	        }
	    }

	    birthdayValidation('#dateofbirth');
	    registrationAddressFormValidation();
	}

	function checkPasswordMismatch() {
	    $('.js-registration-button').on('click', function () {
	        var password = $('#registration-form-password').val();
	        var passwordConfirm = $('#registration-form-passwordconfirm');

	        if (password && passwordConfirm.val()) {
	            if (password !== passwordConfirm.val()) {
	                var error = passwordConfirm.data('password-mismatch');
	                passwordConfirm.addClass('is-invalid custom-error');
	                passwordConfirm.parents('.cc-form-group').find('.cc-text-message').text(error);
	            }
	        } else {
	            passwordConfirm.removeClass('is-invalid custom-error');
	        }
	    });
	}

	function validateEmail($emailEl) {
	    var email = $emailEl.val();
	    if (email) {
	        email = email.trim();
	        $emailEl.val(email);
	        email = email.toLowerCase();
	    }
	    valid_email = isValidEmailAddress(email);

	    if (email && email.length > 0 && valid_email && email !== registration_form_email_oldVal) {
	        //hide error message if a different email is entered
	        $emailEl.removeClass('is-invalid custom-error');
	        user_already_registered = false;
	        use_another_email = false;

	        var url = $emailEl.attr('actionurl');
	        var data = {
	            email: email
	        };

	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: 'json',
	            data: data,
	            success: function success(data) {
	                if (data.success) {
	                    //ok
	                    $.spinner().stop();
	                    $('#registration-form-email').closest('.cc-content-input').addClass('is-valid');
	                } else {
	                    user_already_registered = true;
	                    $('#registration-form-email').addClass('is-invalid custom-error');
	                    $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                    $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	                    $.spinner().stop();
	                }
	                registration_form_email_oldVal = email;
	                customerId_by_email = data.customerId;

	                if (email_by_phone) {
	                    //check entered email with the email from CRM (if phone entered)
	                    if ($checkEmailConsistency && registration_form_email_oldVal !== email_by_phone) {
	                        if (!user_already_registered) {
	                            use_another_email = true;
	                            $('#registration-form-email').addClass('is-invalid custom-error');
	                            $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(data.emailMismatch);
	                            $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	                        }
	                    }
	                } else {
	                    //email from CRM is null, check customer ids (if phone entered)
	                    if (customerId_by_phone && customerId_by_email && customerId_by_email !== customerId_by_phone) {
	                        if ($checkEmailConsistency && !user_already_registered) {
	                            use_another_email = true;
	                            $('#registration-form-email').addClass('is-invalid custom-error');
	                            $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(data.emailMismatch);
	                            $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	                        }
	                        if (!hasValidLoyaltyEmail) {
	                            $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(use_same_number_string);
	                            $('#registration-form-email').addClass('is-invalid custom-error');
	                            $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	                        }
	                    }
	                }

	                if (!number_already_registered && registration_form_phone_oldVal && valid_number && customerId_by_email) {
	                    $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(use_same_number_string);
	                    $('#registration-form-email').addClass('is-invalid custom-error');
	                    $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	                }
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    } else if (!valid_email) {
	        registration_form_email_oldVal = email;
	        $emailEl.parents('.cc-form-group').find('.cc-text-message').text($emailEl.data('invalid-email'));
	        $emailEl.addClass('is-invalid custom-error');
	        $('#registration-form-email').closest('.cc-content-input').removeClass('is-valid');
	    }
	}

	function validatePhone($phoneEl) {
	    var $phoneField = $phoneEl;
	    var phone = $phoneField.val();
	    if (phone) {
	        phone = phone.replace(/\s/g, '');
	        $phoneField.val(phone);
	    }

	    // check the phone length
	    var minLength = $phoneField.attr('minlength'),
	        maxLength = $phoneField.data('max'),
	        errorLengthLabel = '',
	        lengthValid = true;
	    if (minLength && phone.length < parseInt(minLength)) {
	        errorLengthLabel = $phoneField.data('minlength-error');
	        lengthValid = false;
	        registration_form_phone_oldVal = null;
	    }
	    if (maxLength && phone.length > parseInt(maxLength)) {
	        errorLengthLabel = $phoneField.data('maxlength-error');
	        lengthValid = false;
	        registration_form_phone_oldVal = null;
	    }
	    //if the length is not valid, show the related error
	    if (lengthValid) {
	        //if the phone is not present, show the related error
	        if (phone) {
	            //check if the phone was the same as the last validated to prevent useless API calls
	            if (phone !== registration_form_phone_oldVal) {
	                //hide error message if a different phone is entered
	                $('#form-phone-message').hide();
	                $phoneField.closest('.cc-phone-input-box').removeClass('is-invalid custom-error');
	                $phoneField.removeClass('is-invalid custom-error custom-error-is-loyalty');

	                valid_number = true;
	                number_already_registered = false;

	                if (valid_email && !user_already_registered) {
	                    $('#registration-form-email').removeClass('is-invalid custom-error');
	                }

	                var url = $phoneField.attr('actionurl');
	                var data = {
	                    phoneNumber: phone
	                };

	                $.spinner().start();
	                $.ajax({
	                    url: url,
	                    type: 'POST',
	                    dataType: 'json',
	                    data: data,
	                    // eslint-disable-next-line complexity
	                    success: function success(data) {
	                        if (data.success) {
	                            $.spinner().stop();
	                            $phoneField.closest('.cc-content-input').addClass('is-valid');
	                            $phoneField.closest('.cc-phone-input-box').removeClass('is-invalid custom-error');
	                            $phoneField.closest('.cc-phone-input-box').addClass('is-valid');
	                            // enable the otp button, if present
	                            $('body').trigger('otp:validPhone');
	                        } else if (data.isLoyalty) {
	                            number_already_registered = true;
	                            if (data.hasValidEmail) {
	                                $('#form-phone-message').text(data.loyaltyPhoneMessage);
	                                $('#form-phone-message').show();
	                                $phoneField.closest('.cc-content-input').removeClass('is-valid');
	                                $phoneField.closest('.cc-phone-input-box').removeClass('is-valid');
	                            }
	                            if (data.checkCustomerId === false) {
	                                $phoneField.parents('.cc-form-group').find('.cc-text-message').text(data.loyaltyPhoneError);
	                                $phoneField.addClass('is-invalid custom-error');
	                                $phoneField.closest('.cc-content-input').removeClass('is-valid');
	                                $phoneField.closest('.cc-phone-input-box').removeClass('is-valid');
	                            }
	                            // enable the otp button, if present
	                            $('body').trigger('otp:validPhone');
	                            $.spinner().stop();
	                        } else if (data.error) {
	                            $phoneField.parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                            $phoneField.addClass('is-invalid custom-error');
	                            $phoneField.closest('.cc-phone-input-box').addClass('is-invalid custom-error');
	                            $phoneField.closest('.cc-phone-input-box').removeClass('is-valid');
	                            $phoneField.closest('.cc-content-input').removeClass('is-valid');
	                            valid_number = false;
	                            if (valid_email && !user_already_registered) {
	                                $('#registration-form-email').removeClass('is-invalid custom-error');
	                            }
	                            use_another_email = false;
	                            $.spinner().stop();
	                        }
	                        registration_form_phone_oldVal = phone;
	                        email_by_phone = data.email ? data.email.toLowerCase() : null;
	                        customerId_by_phone = data.customerId;
	                        use_same_number_string = data.phoneMismatch;
	                        hasValidLoyaltyEmail = data.hasValidEmail && data.hasValidEmail === true;

	                        if (!data.error) {
	                            if (email_by_phone) {
	                                //check entered email with the email from CRM
	                                if ($checkEmailConsistency && registration_form_email_oldVal && registration_form_email_oldVal.length > 0 && registration_form_email_oldVal !== email_by_phone) {
	                                    if (valid_email && !user_already_registered) {
	                                        use_another_email = true;
	                                        $('#registration-form-email').addClass('is-invalid custom-error');
	                                        $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(data.emailMismatch);
	                                    }
	                                }
	                            } else {
	                                //email from CRM is null, check customer ids
	                                if (customerId_by_email && customerId_by_email !== customerId_by_phone) {
	                                    if (!customerId_by_phone) {
	                                        $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(use_same_number_string);
	                                    } else if ($checkEmailConsistency) {
	                                        $('#registration-form-email').parents('.cc-form-group').find('.cc-text-message').text(data.emailMismatch);
	                                        use_another_email = true;
	                                    }
	                                    $('#registration-form-email').addClass('is-invalid custom-error');
	                                } else if (valid_email && !use_another_email && !user_already_registered) {
	                                    $('#registration-form-email').removeClass('is-invalid custom-error');
	                                }
	                            }
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        } else {
	            $('#form-phone-message').hide();
	            $phoneField.closest('.cc-content-input').removeClass('is-valid');
	            $phoneField.closest('.cc-phone-input-box').removeClass('is-valid');
	            $phoneField.closest('.cc-phone-input-box').addClass('is-invalid custom-error');
	            // enable the otp button, if present
	            $('body').trigger('otp:invalidPhone');
	        }
	    } else {
	        $('#form-phone-message').hide();
	        $phoneField.parents('.cc-form-group').find('.cc-text-message').text(errorLengthLabel);
	        $phoneField.closest('.cc-content-input').removeClass('is-valid');
	        $phoneField.addClass('is-invalid custom-error');
	        $phoneField.closest('.cc-phone-input-box').removeClass('is-valid');
	        $phoneField.closest('.cc-phone-input-box').addClass('is-invalid custom-error');
	        // enable the otp button, if present
	        $('body').trigger('otp:invalidPhone');
	    }
	}

	function validateRUTOnRegistration(field) {
	    var $field = $(field);
	    if ($field.data('rut-validation-enable')) {
	        var rut = $field.val();
	        var minLength = $field.attr('minlength'),
	            maxLength = $field.data('max'),
	            rutlenght = rut.replace(/[.,-]/g, '').toUpperCase().trim().length;
	        var isFieldValid = false;
	        if (rutlenght >= parseInt(minLength) && rutlenght <= parseInt(maxLength)) {
	            var rutArray = rut.replace(/[.,-]/g, '').toUpperCase().trim().split(""),
	                reversedRUT = rutArray.map(Number).reverse();
	            var sum = 0;
	            var multiplier = 2;

	            for (var i = 1; i < reversedRUT.length; i++) {
	                sum += reversedRUT[i] * multiplier;
	                multiplier = multiplier === 7 ? 2 : multiplier + 1;
	            }

	            var calculateRut = sum - Math.floor(sum / 11) * 11;
	            var checkDigit = 11 - calculateRut;
	            var lastDigit = rutArray[rutArray.length - 1];

	            if (checkDigit === 11) {
	                checkDigit = 0;
	                lastDigit = parseInt(rutArray[rutArray.length - 1]);
	            } else if (checkDigit === 10) {
	                checkDigit = 'K';
	            } else {
	                lastDigit = parseInt(rutArray[rutArray.length - 1]);
	            }

	            if (checkDigit === lastDigit) {
	                isFieldValid = true;
	            } else {
	                isFieldValid = false;
	            }
	            field = field[0];
	        }
	        if (isFieldValid) {
	            $field.siblings('.cc-error-message').hasClass('is-invalid');
	            $field.siblings('.cc-error-message').removeClass('is-invalid');
	            //removeInvalid(field);
	            $('.cc-valid-success').removeClass('d-none');
	        } else {
	            field = $field[0];
	            field.setCustomValidity($field.data('rut-validation-error'));
	            $field.siblings('.cc-error-message').addClass('is-invalid');
	            //insertInvalid(field);
	            $('.cc-valid-success').addClass('d-none');
	        }
	        return isFieldValid;
	    }
	}

	/**
	 * Validate the RUT for Chile
	 */
	function validateRut(field) {
	    var $field = $(field);
	    var isValid = validateRUTOnRegistration($field);
	    var rut = $field.val().replace(/[.,-]/g, '').toUpperCase().trim();
	    if (isValid) {
	        var url = $field.attr('actionurl');
	        var data = {
	            singleTaxID: rut
	        };

	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: 'json',
	            data: data,
	            // eslint-disable-next-line complexity
	            success: function success(data) {
	                if (data.success) {
	                    $.spinner().stop();
	                    $('#rut-validation-registration').closest('.cc-content-input').addClass('is-valid');
	                    $(field).removeClass('is-invalid custom-error');
	                } else if (data.error) {
	                    $field.parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                    $field.addClass('is-invalid custom-error');
	                    $field.closest('.cc-content-input').removeClass('is-valid');
	                    $.spinner().stop();
	                }
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    } else {
	        $field.parents('.cc-form-group').find('.cc-text-message').text($field.data('rut-validation-error'));
	        $field.addClass('is-invalid custom-error');
	        $('#rut-validation-registration').closest('.cc-content-input').removeClass('is-valid');
	    }
	}

	function validateDNIPattern(field) {
	    // Ensure `field` is a jQuery object
	    var $field = $(field);
	    // Get the pattern and validation message
	    var pattern = $field.attr('pattern');
	    var validationMessage = $field.data('pattern-mismatch');
	    var value = $field.val();

	    // Check if the value matches the pattern
	    if (pattern && !new RegExp(pattern).test(value)) {
	        // Set custom validity message
	        $field[0].setCustomValidity($field.data('rut-validation-error'));
	        validationMessage = $field[0].validationMessage;

	        // Add invalid styles and update feedback message
	        $field.addClass('is-invalid');
	        var $feedback = $field.parents('.cc-form-group').find('.invalid-feedback');

	        $feedback.find('.cc-text-message').text(validationMessage);
	        // Hide success indicator and remove success styles
	        $('.cc-valid-success').addClass('d-none');
	        $field.closest('.cc-content-input').removeClass('is-valid');
	    } else {
	        // Clear custom validity and update styles for valid input
	        $field[0].setCustomValidity('');
	        $field.removeClass('is-invalid');
	        $('.cc-valid-success').removeClass('d-none');
	        $field.closest('.cc-content-input').addClass('is-valid');
	    }
	}

	//Peruvian Dni
	function validateDni(field) {
	    var $field = $(field);
	    var isValid = true;
	    var dni = $field.val().replace(/[.,-]/g, '').toUpperCase().trim();
	    // Extra validation for DNI's regex
	    $field.trigger('validateDNIPattern', $field);
	    // We run the backend RUT validation only if the DNI is within the requirements
	    if (!$field.hasClass('is-invalid')) {
	        var url = $field.attr('actionurl');
	        var data = {
	            singleTaxID: dni
	        };

	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: 'json',
	            data: data,
	            // eslint-disable-next-line complexity
	            success: function success(data) {
	                if (data.success) {
	                    $.spinner().stop();
	                    $('#dni-validation-registration').closest('.cc-content-input').addClass('is-valid');
	                    $('.cc-valid-success').removeClass('d-none');
	                    $(field).removeClass('is-invalid custom-error');
	                } else if (data.error) {
	                    $field.parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                    $field.addClass('is-invalid custom-error');
	                    $('.cc-valid-success').addClass('d-none');
	                    $field.closest('.cc-content-input').removeClass('is-valid');
	                    $.spinner().stop();
	                }
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    } else {
	        $field.parents('.cc-form-group').find('.cc-text-message').text($field.data('dni-validation-error'));
	        $field.addClass('is-invalid custom-error');
	        $('#dni-validation').closest('.cc-content-input').removeClass('is-valid');
	    }
	}

	function updateDniInputMaxLength(selectedInput) {
	    var input = $('#dni-validation-registration');
	    if (selectedInput === 'CE') {
	        input.prop('maxLength', 9);
	    }
	    if (selectedInput === 'DNI') {
	        input.prop('maxLength', 8);
	    }
	}

	module.exports = {
	    register: function register() {
	        $('form.registration').submit(function (e) {
	            var form = $(this);
	            e.preventDefault();

	            // logic to perform additional validation that are not directly triggered
	            doAdditionalErrorCheck(form[0]);

	            if (form.find('.js-province-autocomplete').length) {
	                form.find('.js-province-autocomplete').prop('disabled', false);
	            }

	            var isValid = $('.custom-error').length < 1 && $('.custom-birthday-error').length < 1;
	            if (isValid) {
	                var url = form.attr('action');
	                form.spinner().start();
	                $('form.registration').trigger('login:register', e);
	                $.ajax({
	                    url: url,
	                    type: 'post',
	                    dataType: 'json',
	                    data: form.serialize(),
	                    success: function success(data) {
	                        $('.generic-error').addClass('cc-hide');
	                        form.spinner().stop();
	                        if (!data.success) {
	                            if (form.find('.js-province-autocomplete').length) {
	                                form.find('.js-province-autocomplete').prop('disabled', true);
	                            }
	                            formValidation(form, data);
	                        } else if (data.addressValidation) {
	                            $('.js-suggested-addresses').html(data.modalHtml);
	                            $('.js-suggested-addresses').removeClass('d-none');
	                        } else {
	                            var email = $('.js-check-email').val();
	                            var phone = $('#registration-form-phone').val();
	                            //trigger the analytics registration event
	                            $('body').trigger('analytics:registration', {
	                                customerId: data.customerId,
	                                email: email,
	                                phone: phone,
	                                customerCrmId: data.customerCrmId
	                            });
	                            // push the cart data to GTM to let sellgent match the products added
	                            $('body').trigger('analytics:pushBasketData', data.gtmData);
	                            // Passing the user credentials to Reskyt (Registration flow)
	                            var userCreds = {
	                                user: email,
	                                password: $('.js-form-password').val()
	                            };
	                            $('body').trigger('reskit:credentials_created', userCreds);
	                            location.href = data.redirectUrl;
	                        }
	                    },
	                    error: function error(err) {
	                        if (err.responseJSON.redirectUrl) {
	                            window.location.href = err.responseJSON.redirectUrl;
	                        } else {
	                            var errorElement = $('.generic-error');
	                            errorElement.html(err.responseJSON.errorMessage);
	                            errorElement.removeClass('cc-hide');
	                            if (form.find('.js-province-autocomplete').length) {
	                                form.find('.js-province-autocomplete').prop('disabled', true);
	                            }
	                            $('html, body').animate({
	                                scrollTop: errorElement.offset().top - 100
	                            }, 500);
	                        }

	                        form.spinner().stop();
	                    }
	                });
	            }
	            checkPasswordMismatch();
	            return false;
	        });
	    },
	    checkAdditionalError: function checkAdditionalError() {
	        $('.js-registration-button').on('click', function () {
	            var form = $('form.registration');
	            doAdditionalErrorCheck(form[0]);
	        });
	    },

	    showOptionalAddressesOnLoad: function showOptionalAddressesOnLoad() {
	        $(document).ready(function () {
	            $('#shippingBillingSame').trigger('change');
	        });
	    },

	    showOptionalAddresses: function showOptionalAddresses() {
	        $('body').on('change', '#shippingBillingSame', function () {
	            var $billingAddressSameAsShippingElement = $(this);
	            var $customerForm = $billingAddressSameAsShippingElement.closest('form');
	            var isShippingBillingSameChecked = $billingAddressSameAsShippingElement.is(':checked'),
	                $customerBillingAddressList = $customerForm.find('.js-addressListContainerSection[data-section="billing"]'),
	                $billingAddressSection = $customerForm.find('.addressContainer.billing');
	            if (isShippingBillingSameChecked) {
	                if ($customerBillingAddressList.length) {
	                    // logged in customer -> hide the address list
	                    $customerBillingAddressList.addClass('d-none');
	                } else {
	                    // guest customer -> hide the billing address form
	                    $billingAddressSection.addClass('d-none');
	                }
	                $('.js-customer-billing-title').addClass('d-none');
	            } else {
	                if ($customerBillingAddressList.length) {
	                    // logged in customer -> show the address list
	                    $customerBillingAddressList.removeClass('d-none');
	                } else {
	                    // guest customer -> show the billing address form
	                    $billingAddressSection.removeClass('d-none');
	                }
	                $('.js-customer-billing-title').removeClass('d-none');
	            }
	        });
	    },

	    addressValidationSubmit: function addressValidationSubmit() {
	        $('body').on('click', '.js-address-validation-confirm', function (e) {
	            e.preventDefault();
	            var $selectedAddress = $('#addressSuggestionModal').find('.js-address-list:checked');
	            var $form = $('form[id="myform"]');

	            var isSuggestedAddressSelected = !$selectedAddress.hasClass('js-current-address');
	            if (isSuggestedAddressSelected) {
	                var attrs = $selectedAddress.data();
	                $('input[name$=_address]', $form).val(attrs.address1);
	                $('input[name$=_address2]', $form).val(attrs.address2);
	                // $('select[name$=_district],input[name$=_district]', $form).val(attrs.district);
	                // $('select[name$=_subdistrict],input[name$=_subdistrict]', $form).val(attrs.subdistrict);
	                $('select[name$=_city],input[name$=_city]', $form).val(attrs.city);
	                $('input[name$=_zipCode]', $form).val(attrs.postalCode);
	                $('select[name$=_zipCode]', $form).val(attrs.postalCode);
	                $('select[name$=_stateCode],input[name$=_stateCode]', $form).val(attrs.stateCode);
	            }

	            $('[name$=isValidated]', $form).val('true');
	            $('#addressSuggestionModal').hide();

	            // submit registration
	            $form.find('button[type="submit"]').trigger('click');
	        });

	        $('body').on('click', '.js-close-suggestionModal', function (e) {
	            e.preventDefault();
	            $('#addressSuggestionModal').hide();
	        });
	    },

	    /**
	    * Script that checks if legal radio button are accepted.
	    * Mandatory to be accepted in some countries during registration.
	    */
	    checkLegalRadioButtons: function checkLegalRadioButtons() {
	        $('input[type=radio][name=' + formName + '_customer_termsAndConditions]').on('change', function () {
	            validateLegalButton($('form.registration')[0], 'termsAndConditions');
	        });

	        $('input[type=radio][name=' + formName + '_customer_marketingOptIn]').on('change', function () {
	            validateLegalButton($('form.registration')[0], 'marketingOptIn');
	        });

	        $('input[type=radio][name=' + formName + '_customer_profilation]').on('change', function () {
	            validateLegalButton($('form.registration')[0], 'profilation');
	        });
	    },

	    /**
	    * Ajax script that checks if an email already exists on SFCC/CRM
	    */
	    checkEmail: function checkEmail() {
	        $('.js-check-email').on('blur', function () {
	            var $email = $(this);
	            validateEmail($email);
	        });
	        $('#myform').on('click', 'button[type="submit"]', function () {
	            var $email = $('.js-check-email');
	            // validate the email only in case it's not an offline registration completion (IT CZ and SK)
	            var $crmIdInput = $('#myform').find('.js-customerCRMid');
	            if (!($crmIdInput.length && $crmIdInput.val() !== '')) {
	                validateEmail($email);
	            }
	        });
	    },

	    /**
	     * Ajax script that checks if the phone already exists on CRM
	     */
	    checkPhone: function checkPhone() {
	        $('#registration-form-phone').on('blur', function () {
	            var $phone = $(this);
	            validatePhone($phone);
	        });
	        $('#myform').on('click', 'button[type="submit"]', function () {
	            var $phone = $('#registration-form-phone');
	            validatePhone($phone);
	        });
	    },
	    /**
	     * Ajax script that checks if the rut already exists on CRM
	     */
	    checkRut: function checkRut() {
	        $('#rut-validation-registration').on('change', function () {
	            var $rut = $(this);
	            validateRut($rut);
	        });
	    },
	    //Peruvian Dni
	    checkDni: function checkDni() {
	        $('#dni-validation-registration').on('change', function () {
	            var $dni = $(this);
	            validateDni($dni);
	        });
	    },

	    dniInputMaxLength: function dniInputMaxLength() {
	        $('#documentPick').on('change', function () {
	            var $selectedInput = $(this).find('option:selected').val();
	            updateDniInputMaxLength($selectedInput);
	        });
	    },

	    dniAvoidLetter: function dniAvoidLetter() {
	        $('#dni-validation-registration').on('input', function () {
	            this.value = this.value.replace(/[^0-9]/g, '');
	        });
	    },

	    /**
	         * Ajax script that checks if the cedula already exists on CRM
	         */
	    checkCedula: function checkCedula() {
	        $('#cedula-validation').on('change', function () {
	            var $field = $(this);
	            clientSideValidation.validateCedulaForm($field);
	            var singleTaxID = $field.val().replace(/[.,-]/g, '').toUpperCase().trim();
	            var isValid = $('#cedula-validation.is-invalid').length > 0;
	            if (!isValid) {
	                var url = $field.attr('actionurl');
	                var data = {
	                    singleTaxID: singleTaxID
	                };
	                $.spinner().start();
	                $.ajax({
	                    url: url,
	                    type: 'POST',
	                    dataType: 'json',
	                    data: data,
	                    // eslint-disable-next-line complexity
	                    success: function success(data) {
	                        if (data.success) {
	                            $.spinner().stop();
	                            $('#cedula-validation').closest('.cc-content-input').addClass('is-valid');
	                            $('.cc-valid-success').removeClass('d-none');
	                            $field.removeClass('is-invalid custom-error');
	                        } else if (data.error) {
	                            $field.parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                            $field.addClass('is-invalid custom-error');
	                            $('.cc-valid-success').addClass('d-none');
	                            $field.closest('.cc-content-input').removeClass('is-valid');
	                            $.spinner().stop();
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            } else {
	                $field.parents('.cc-form-group').find('.cc-text-message').text($field.data('rut-validation-error'));
	                $field.addClass('is-invalid custom-error');
	                $('#cedula-validation').closest('.cc-content-input').removeClass('is-valid');
	            }
	        });
	    },

	    // Check the mismatch between the password field and the password confirmation field focusing out of "password"
	    checkPassword: function checkPassword() {
	        $('#registration-form-password').on('blur', function () {
	            var password = $(this).val();
	            password = password.trim();
	            $(this).val(password);
	            var passwordConfirm = $('#registration-form-passwordconfirm').val();

	            if (password && passwordConfirm) {
	                if (password !== passwordConfirm) {
	                    var error = $('#registration-form-passwordconfirm').data('password-mismatch');
	                    $('#registration-form-passwordconfirm').addClass('is-invalid custom-error');
	                    $('#registration-form-passwordconfirm').parents('.cc-form-group').find('.cc-text-message').text(error);
	                } else {
	                    $('#registration-form-passwordconfirm').removeClass('is-invalid custom-error');
	                }
	            } else {
	                $('#registration-form-passwordconfirm').removeClass('is-invalid custom-error');
	            }
	        });
	    },
	    // Check the mismatch between the password field and the password confirmation field focusing out of "password confirmation"
	    checkPasswordConfirm: function checkPasswordConfirm() {
	        $('#registration-form-passwordconfirm').on('blur', function () {
	            var password = $('#registration-form-password').val();
	            var passwordConfirm = $(this).val();
	            passwordConfirm = passwordConfirm.trim();
	            $(this).val(passwordConfirm);

	            if (password && passwordConfirm) {
	                if (password !== passwordConfirm) {
	                    var error = $(this).data('password-mismatch');
	                    $(this).addClass('is-invalid custom-error');
	                    $(this).parents('.cc-form-group').find('.cc-text-message').text(error);
	                } else {
	                    $(this).removeClass('is-invalid custom-error');
	                }
	            } else {
	                $(this).removeClass('is-invalid custom-error');
	            }
	        });
	    },

	    checkPasswordMismatch: function checkPasswordMismatch() {
	        $('.js-registration-button').on('click', function () {
	            var password = $('#registration-form-password').val();
	            var passwordConfirm = $('#registration-form-passwordconfirm');

	            if (password && passwordConfirm.val()) {
	                if (password !== passwordConfirm.val()) {
	                    var error = passwordConfirm.data('password-mismatch');
	                    passwordConfirm.addClass('is-invalid custom-error');
	                    passwordConfirm.parents('.cc-form-group').find('.cc-text-message').text(error);
	                }
	            } else {
	                passwordConfirm.removeClass('is-invalid custom-error');
	            }
	        });
	    },

	    /*Remove space chars from all input fields*/

	    removeSpacesChars: function removeSpacesChars() {
	        $('input[type="text"], input[type="string"]').on('blur', function () {
	            var inputText = $(this).val();
	            inputText = inputText.trim();
	            $(this).val(inputText);
	        });
	    },

	    /**
	     * Autocomplete city and state field on pincode entered, please insert the class "js-checkPincode" only for countries that requires back end validation
	     */
	    cityAndStateAutocomplete: function cityAndStateAutocomplete() {
	        $('#registration-form-zipCode.js-checkPincode').on('blur', function () {
	            var url = $(this).data('url');
	            var zipCode = $(this).val().trim();
	            var data = {
	                zipcode: zipCode
	            };

	            if (zipCode && zipCode.length > 0 && zipCode !== registration_form_zipCode_oldVal) {
	                //clear fields and errors
	                $('#registration-form-city').val('');
	                $('#registration-form-state').val('');
	                $(this).removeClass('is-invalid custom-error');
	                //$(this).parents('.cc-form-group').find('.cc-error-message').hide();
	                $.spinner().start();
	                $.ajax({
	                    url: url,
	                    type: 'POST',
	                    dataType: 'json',
	                    data: data,
	                    success: function success(data) {
	                        if (data.success) {
	                            var city = data.result.responseTextCity;
	                            var state = data.result.responseTextState;
	                            $('#registration-form-city').val(city);
	                            $('#registration-form-state').val(state);
	                            registration_form_zipCode_oldVal = zipCode;
	                            $.spinner().stop();
	                        } else {
	                            $('#registration-form-zipCode').addClass('is-invalid custom-error');
	                            $('#registration-form-zipCode').parents('.cc-form-group').find('.cc-text-message').text(data.error);
	                            registration_form_zipCode_oldVal = zipCode;
	                            $.spinner().stop();
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    },

	    cityAutocomplete: function cityAutocomplete() {
	        $('body').on('blur', '.js-city-autocomplete', function () {
	            var $zipCodeElement = $(this);
	            var $form = $zipCodeElement.closest('form'),
	                url = $zipCodeElement.data('url'),
	                zipCode = $zipCodeElement.val().trim().replaceAll(/\s/g, '');
	            var newZipCode = $zipCodeElement.hasClass('js-format-zipCode') ? zipCode.substr(0, 3) + " " + zipCode.substr(3) : zipCode,
	                formContext = $form.closest('form').attr('name');

	            var data = {
	                newZipCode: newZipCode,
	                formContext: formContext,
	                addressContext: 'customer'
	            };
	            $zipCodeElement.val(newZipCode);
	            $zipCodeElement.removeClass('is-invalid custom-error');
	            $.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'GET',
	                data: data,
	                success: function success(data) {
	                    $form.find('.js-city-container').closest('.editable-block').html(data);
	                    // Set the province (IT scenario)
	                    if ($('.js-province-autocomplete-value').length && $('.js-province-autocomplete').length) {
	                        var provinceAutoSelectedId = $('.js-province-autocomplete-value').data('province');
	                        $('select.js-province-autocomplete').val(provinceAutoSelectedId).data('selected-id', provinceAutoSelectedId);
	                    } else if ($('.js-province-autocomplete').length) {
	                        $('select.js-province-autocomplete').val('').data('selected-id', '');
	                    }

	                    var $autoCompleteElementUpdated = $($form.find('.js-city-container select.js-city-field-autocomplete'));
	                    if ($autoCompleteElementUpdated.data('error')) {
	                        var errorMessage = $autoCompleteElementUpdated.data('error');
	                        $zipCodeElement.addClass('is-invalid custom-error');
	                        $zipCodeElement.parents('.cc-form-group').find('.invalid-feedback .cc-text-message').text(errorMessage);
	                    }
	                    var $selectPicker = $('.selectpicker');
	                    if ($selectPicker.length) {
	                        $selectPicker.selectpicker('refresh');
	                    }
	                    $.spinner().stop();
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    },

	    datePicker: function datePicker() {
	        var $datepicker = $('.js-input_datepicker');

	        function formatAndSetDate(element, dateString) {
	            var characterToSplit = dateString.indexOf('/') >= 0 ? '/' : '.';
	            var splitDate = dateString.split(characterToSplit);
	            if (splitDate.length === 3) {
	                var dateFixed = splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
	                element.attr("value", dateString);
	                $('#dateofbirth').val(dateFixed);
	                $('#datepicker').removeClass('is-invalid custom-error');
	            }
	        }

	        var minAgeValue = $('.js-input_datepicker').data('min-age') || 18;
	        $('.js-input_datepicker').datepicker({
	            yearRange: '-100:+0',
	            dateFormat: 'dd/mm/yy',
	            defaultDate: '-' + minAgeValue + 'y',
	            maxDate: '-' + minAgeValue + 'y',
	            inline: true,
	            changeMonth: true,
	            changeYear: true,
	            onSelect: function onSelect(selectedDate) {
	                formatAndSetDate($(this), selectedDate);
	            }
	        });

	        $datepicker.on('blur', function () {
	            var selectedDate = $(this).val();
	            if (selectedDate) {
	                formatAndSetDate($(this), selectedDate);
	            }
	        });
	    },

	    datepickerFixPosition: function datepickerFixPosition() {
	        $('body').on('click', '.js-input_datepicker', function (e) {
	            e.preventDefault();

	            var $boxToAppend = $(this).closest('.datepicker-box');
	            $boxToAppend.append($('#ui-datepicker-div'));
	        });
	    },

	    // Check the dob was populated
	    checkDateOfBirthday: function checkDateOfBirthday() {
	        $('#datepicker').on('blur', function () {
	            var dob = $(this).val();
	            if (!dob) {
	                var error = $('#datepicker').data('invalid-date-message');
	                $('#datepicker').addClass('is-invalid custom-error');
	                $('#datepicker').parents('.cc-form-group').find('.cc-text-message').text(error);
	            } else {
	                $('#datepicker').removeClass('is-invalid custom-error');
	            }
	        });
	    }
	};

	$(document).ready(function () {
	    registrationAddressFormValidation();
	    // Counter for each character input in address fields
	    function updateFieldCounterByClass(fieldClass, counterSelector) {
	        var $field = $(fieldClass);
	        var $counter = $(counterSelector);

	        $field.on('input', function () {
	            var currentLength = $field.val().length;
	            $counter.text(currentLength);
	        });
	    }

	    // Initialize counters for address1, address2, and address3
	    updateFieldCounterByClass('.address1', '.address1 ~ .cc-counter .js-field-length-counter');
	    updateFieldCounterByClass('.address2', '.address2 ~ .cc-counter .js-field-length-counter');
	    updateFieldCounterByClass('.address3', '.address3 ~ .cc-counter .js-field-length-counter');
	});

/***/ })

/******/ });